import { Language } from 'src/types/configV2';

import { rtlLanguages } from '../../config/i18n';

export const isRtlLanguage = (languageToCheck: Language) => {
    return rtlLanguages.includes(languageToCheck.lang);
};
